angular.module('ikeweb.map', [
        'ikeweb.spike.capture',
        'ikeweb.shared.map.leaflet',
        'ikeweb.shared.util',
        'ikeweb.shared.input',
        'ikeweb.shared.layout',
        'ikeweb.shared.messaging',
        'ikeweb.shared.map',
        'LocalStorageModule'
    ])
    .config(['leafletIkeMapFactoryProvider', '$provide', function(leafletIkeMapFactoryProvider, $provide) {
        $provide.provider('ikeMapFactory', leafletIkeMapFactoryProvider);
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/map.module.js
// module id = 582
// module chunks = 0